<a [href]="url" class="signup-link" title="{{ action }} with GitHub">
  <img src="/assets/images/github_logo.svg" alt="{{ action }} with Github" />
</a>
